import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import CommonSelect from '../../../../../Common/Controller/Select';
import CommonTextInput from '../../../../../Common/Controller/Text';
import StyledModalInputContainer from '../../../../../../style/Inventory/Modal/EditModal/StyledModalInputContainer';
import {
  changeSelect,
  changeText,
  blurUpperCaseChange,
  changeDay,
} from '../../../../../../util/Inventory/Common/Handler/controllerChangeHandler';
import { REGEX_ONLY_NUMBER_ONLY_ALPHABET } from '../../../../../../constant/Common/Regex';
import CommonDate from '../../../../../Common/Controller/Date';
import CommonAutoComplete from '../../../../../Common/Controller/AutoComplete';
import useGetActiveWOListByCont from '../../../../../../hook/Common/Data/useGetActiveWOByCont';
import { createMandatorySelectOption } from '../../../../../../util/Common/Option/Generator/selectOptionCreator';

const ContainerInfo = ({ data, selectOptions, isEditable }) => {
  const { setValue } = useFormContext();

  const contNo = useWatch({ name: 'cont_no', defaultValue: data?.cont_no });
  const woNo = useWatch({ name: 'wo_no', defaultValue: data?.wo_no });

  const { isLoading: isLoadingActiveWOList, activeWOList } =
    useGetActiveWOListByCont({ contNo });

  return (
    <StyledModalInputContainer>
      <div>
        <CommonTextInput
          label="CONT #"
          inputName="cont_no"
          defaultValue={data?.cont_no || null}
          onChangeHandler={changeText}
          regex={REGEX_ONLY_NUMBER_ONLY_ALPHABET}
          onBlurHandler={blurUpperCaseChange}
          disabled={!isEditable || !!woNo}
          maxLength={11}
          required
        />
      </div>
      <div>
        <CommonAutoComplete
          label="WO #"
          inputName="wo_no"
          option={createMandatorySelectOption({
            items: activeWOList,
            labelKey: 'wo_no',
            valueKey: 'wo_no',
          })}
          defaultValue={data?.wo_no}
          disabled={!isEditable || !contNo}
          isLoading={isLoadingActiveWOList}
          onChangeHandler={({ e, onChange, selectProps }) => {
            onChange?.(selectProps?.value);

            /** Set RFD value by Work Order */
            const selectedWO = activeWOList?.find(
              wo => wo?.wo_no === selectProps?.value,
            );
            setValue('rfd', selectedWO?.rfd || null);
          }}
        />
      </div>
      <div>
        <CommonDate
          label="RFD"
          inputName="rfd"
          defaultValue={data?.rfd || null}
          onChangeHandler={changeDay}
          disabled
        />
      </div>
      <div>
        {/* Intentionally left blank for layout; reserved for future items */}
      </div>
      <div>
        <CommonSelect
          label="SZ"
          inputName="size"
          defaultValue={data?.size || ''}
          onChangeHandler={changeSelect}
          option={selectOptions.sizeOption}
          disabled={!isEditable}
          required
        />
      </div>
      <div>
        <CommonSelect
          label="TYPE"
          inputName="type"
          defaultValue={data?.type || ''}
          onChangeHandler={changeSelect}
          option={selectOptions.typeOption}
          disabled={!isEditable}
          required
        />
      </div>
      <div>
        <CommonSelect
          label="SSL"
          inputName="ssl"
          defaultValue={data?.ssl || ''}
          onChangeHandler={changeSelect}
          option={selectOptions.sslOption}
          disabled={!isEditable}
        />
      </div>
      <div>
        <CommonTextInput
          label="COLOR"
          inputName="color"
          defaultValue={data?.color || null}
          onChangeHandler={changeText}
          disabled={!isEditable}
          maxLength={10}
        />
      </div>
      <div>
        <CommonTextInput
          label="SEAL #"
          inputName="seal"
          defaultValue={data?.seal || null}
          onChangeHandler={changeText}
          disabled={!isEditable}
          maxLength={20}
        />
      </div>
      <div className="w-[388px]">
        <CommonTextInput
          label="REMARKS"
          inputName="remarks"
          defaultValue={data?.remarks || null}
          onChangeHandler={changeText}
          disabled={!isEditable}
          maxLength={50}
        />
      </div>
    </StyledModalInputContainer>
  );
};

export default ContainerInfo;
